import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { Items } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectItems } from '../Selectors/Master/ItemSelectors';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { createJobRateEntry } from '../../Store/PHPSlice/JobRate';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const JobRateEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        itemId: '',
        cut: '0',
        stitch: '0',
        press: '0',
        kaje: '0',
        material: '0',
        extra: '0',
        total: '0',
        contractor: '0',
        userId: userdata?.ID
    });

    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        itemId: fetchItemData
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const itemList = useSelector(selectItems);
    useEffect(() => {
        dispatch(fetchItemData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        const { cut, stitch, press, kaje, material, extra } = formData;
        const sum = [cut, stitch, press, kaje, material, extra]
            .map(Number)
            .reduce((acc, curr) => acc + (isNaN(curr) ? 0 : curr), 0)
            .toFixed(2);
        setFormData(prevData => ({ ...prevData, total: sum }));
    }, [formData.cut, formData.stitch, formData.press, formData.kaje, formData.material, formData.extra]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };





    const handleSubmit = (e) => {
        e.preventDefault();

        dispatch(createJobRateEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                if (result.msg === 'Already Exits') {
                    alert('Already Exits');
                    window.location.reload();
                } else {
                    console.log('POST request successful!', result);
                    // toast.success("Job Rate Added");
                    alert("Job Rate Added");
                    window.location.reload();
                }

                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };



    const handleNavigateItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownItem = [
        {
            label: 'Item',
            id: 'itemId',
            options: itemList?.data || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateItem(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('itemId'),
            handleDropdownClose: () => handleDropdownClose('itemId'),
        }
    ];

    return (
        <>
            <Titlebar data={Items} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Item Job Rate Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {/* <Grid item xs={12} md={6}>
                                </Grid> */}


                                {/* item dropdown */}
                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="itemId">Item :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="itemId"
                                                    id="itemId"
                                                    name="itemId"
                                                    value={formData.itemId}
                                                    onChange={(e) => handleDropdownChange(e, 'itemId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        itemList ? itemList.data.map((val, index) => (
                                                            <MenuItem key={index} value={val.ID}>{val.itemNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {dropdownItem?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                    />
                                ))
                                }

                                <Grid item xs={12}>
                                    <div style={{ marginTop: '1%' }}>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Cutting</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Stitching</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Press</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Kaje</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Material</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Extra</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Total</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Contractor / JW</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='cut'
                                                                value={formData.cut}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='stitch'
                                                                value={formData.stitch}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='press'
                                                                value={formData.press}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='kaje'
                                                                value={formData.kaje}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='material'
                                                                value={formData.material}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='extra'
                                                                value={formData.extra}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                value={formData.total}
                                                                inputProps={{ style: styled.inputTable, readOnly: true }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <TextField
                                                                name='contractor'
                                                                value={formData.contractor}
                                                                onChange={handleChange}
                                                                inputProps={{ style: styled.inputTable }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default JobRateEntry;
